import { createSelector } from 'reselect';

import { returnJS } from 'utils/helpers';

import { initialState } from './reducer';

const selectAdminReferrersDomain = (state) =>
	state.get('adminReferrers', initialState);

const makeSelectReferrers = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('referrers')),
	);

const makeSelectPagination = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('pagination')),
	);

const makeSelectLoading = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('loading')),
	);

const makeSelectError = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('error')),
	);

const makeSelectActionLoading = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('actionLoading')),
	);

const makeSelectActionError = () =>
	createSelector(selectAdminReferrersDomain, (substate) =>
		returnJS(substate.get('actionError')),
	);

export default selectAdminReferrersDomain;
export {
	makeSelectReferrers,
	makeSelectPagination,
	makeSelectLoading,
	makeSelectError,
	makeSelectActionLoading,
	makeSelectActionError,
};
